<div class="file-folders h-full">
  <div class="text-center file-breadcrumbs">
    <div>
      <fa-icon [icon]="folderBreadCrumbSelection.length > 1 ? 'arrow-left' : 'home'" class="circle-icon-btn back-btn" (click)="folderBack()"></fa-icon>
      {{ folderBreadCrumbSelection.length > 1 ? folderBreadCrumbSelection[folderBreadCrumbSelection.length - 1].filename : "Home" }}
      &nbsp;&nbsp;
      @if (isGettingFiles) {
        <fa-icon icon="spinner" animation="spin"></fa-icon>
      }
    </div>
    <div class="d-flex align-items-center">
      <div class="t-12 m-r-10">
        @for (folder of folderBreadCrumbSelection; track folder) {
          <span (click)="selectFolder(folder)">
            /
            <span class="folder">{{ folder?.filename || "Home" }}</span>
          </span>
        }
      </div>
      @if (!batchOperationMode) {
        <fa-icon icon="plus" class="action circle-icon-btn m-r-10" placement="left" [ngbTooltip]="'com.create_folder' | translate" (click)="showCreateFolder()"></fa-icon>
      }
      @if (filesByFolderId[selectedFolder?.id || "Home"]?.length) {
        <fa-icon
          [icon]="batchOperationMode ? 'times' : 'check-square'"
          class="action circle-icon-btn m-r-10"
          [class.red]="batchOperationMode"
          placement="left"
          [ngbTooltip]="(batchOperationMode ? 'sphere.cancel' : 'com.select_files') | translate"
          (click)="batchOperationClicked.next(true)"
        ></fa-icon>
      }
    </div>
  </div>

  <div class="h-full" class="file-folders-container">
    <!-- FOLDERS -->
    @for (folder of displayedFolders; track folder) {
      <div class="list-item hover dontgrow folder" (click)="selectFolder(folder)">
        <div class="list-item-container">
          @if (folder.synced) {
            <fa-icon icon="sync" class="m-r-10" placement="right" ngbTooltip="This folder is synced in Studio One"></fa-icon>
          }
          <img src="./assets/icons/file-icons/folder.png" class="item-image file-icon" alt="Folder icon" />
          <div class="main-data">
            {{ decodeName(folder.filename) }}
            <br />
          </div>
          <div class="right-data-buttons no-hover">
            @if (!batchOperationMode && !folder.synced) {
              <fa-icon icon="ellipsis-h" class="action circle-icon-btn m-r-10" (click)="folderOptions(folder, $event)"></fa-icon>
            }
            @if (!batchOperationMode) {
              <fa-icon icon="chevron-right" class="action m-r-10"></fa-icon>
            }
          </div>
        </div>
      </div>
    }
    <!-- /FOLDERS -->
    <!-- FILES -->
    @if (loadingFiles) {
      <myp-skeleton-loader type="list-item" number="8" extraContainerClass="m-y-20 m-x-10"></myp-skeleton-loader>
    }
    @if (!loadingFiles && !displayedFolders?.length && !filesByFolderId[selectedFolder?.id || "Home"]?.length) {
      <div class="text-center h-full d-flex align-items-center">
        <div class="w-full text-center">
          {{ "com.folder_is_empty" | translate }}
          <br />
          <br />
          <button class="small-btn" (click)="addFileClicked.next(true)">{{ "profile.edit.upload_file" | translate }}</button>
        </div>
      </div>
    }
    @if (!loadingFiles) {
      @for (file of filesByFolderId[selectedFolder?.id || "Home"]; track file) {
        <myp-list-item
          [photo]="
            !workspaceService.imageFiles[file.extension] ? './assets/icons/file-icons/' + (workspaceService.availableFileIcons[file.extension] ? file.extension + '.png' : 'file.png') : file.url
          "
          [showImage]="
            !workspaceService.imageFiles[file.extension] || (workspaceService.imageFiles[file.extension] && workspaceService.fileMap[file.id] && workspaceService.fileMap[file.id].progress == 100)
          "
          [title]="file.type == 'stems' ? 'Stem Upload from Studio One' : file.format_grouping_id ? removeExtension(file.filename) : file.filename"
          [imageRound]="false"
          [subDataHtml]="itemSubData"
          (itemClicked)="fileItemClick(file)"
          [includeChevron]="false"
        >
          <div class="button-content">
            @if (
              contentService.loadingPlayId != file.id &&
              !file.grouping_id &&
              !batchOperationMode &&
              workspaceService.audioFiles[file.extension] &&
              workspaceService.fileMap[file.id] &&
              workspaceService.fileMap[file.id].progress == 100
            ) {
              <fa-icon icon="play" class="action circle-icon-btn m-r-10" (click)="playAudioClicked.next({ file: file, event: $event })"></fa-icon>
            }
            @if (contentService.loadingPlayId == file.id) {
              <fa-icon icon="spinner" animation="spin" class="action circle-icon-btn m-r-10"></fa-icon>
            }
            @if (!batchOperationMode && workspaceService.fileMap[file.id] && workspaceService.fileMap[file.id].progress == 100 && file.type != "stems") {
              <fa-icon icon="download" class="action circle-icon-btn m-r-10" (click)="downloadFileClicked.next({ file: file, event: $event })"></fa-icon>
            }
            @if (!batchOperationMode && !file.synced) {
              <fa-icon icon="ellipsis-h" class="action circle-icon-btn m-r-10" (click)="msgOptions(file, $event)"></fa-icon>
            }
            @if (unReadCounts[file.id] && !batchOperationMode) {
              <span class="m-r-10 unread-count">{{ unReadCounts[file.id] }}</span>
            }
            @if (!batchOperationMode) {
              <fa-icon icon="chevron-right" class="action m-r-10"></fa-icon>
            }
            @if (batchOperationMode) {
              <fa-icon [icon]="file.selectedForBatchOperation ? 'check' : 'minus'" class="action circle-icon-btn m-r-10" [class.purple]="file.selectedForBatchOperation"></fa-icon>
            }
            <ng-template #itemSubData>
              @if (file.type == "stems" && file.grouping_id) {
                <span>
                  {{ contentService.groupedFilesMap[file.grouping_id][0].filename }}
                  <br />
                </span>
                @if (contentService.groupedFilesMap[file.grouping_id][1]) {
                  <span>
                    {{ contentService.groupedFilesMap[file.grouping_id][1].filename }}
                    <br />
                  </span>
                }
                @if (contentService.groupedFilesMap[file.grouping_id][2]) {
                  <span>
                    {{ contentService.groupedFilesMap[file.grouping_id][1].filename }}
                    <br />
                  </span>
                }
                @if (contentService.groupedFilesMap[file.grouping_id].length > 3) {
                  <span>
                    ...plus {{ contentService.groupedFilesMap[file.grouping_id].length - 3 }} more ({{ contentService.groupedFilesMap[file.grouping_id].length }} total)
                    <br />
                  </span>
                }
                @if (contentService.groupedFilesMap[file.grouping_id].length < 3) {
                  <span>
                    {{ contentService.groupedFilesMap[file.grouping_id].length }} total file{{ contentService.groupedFilesMap[file.grouping_id].length > 1 ? "s" : "" }}
                    <br />
                  </span>
                }
              }
              @if (file.format_grouping_id) {
                <div class="d-flex">
                  <span class="m-r-5 d-block">Contains</span>
                  @for (format of contentService.groupedFormatsMap[file.format_grouping_id]; track format) {
                    <span class="file-format-pill">{{ format.extension }}</span>
                  }
                </div>
              }
              @if (file.description) {
                <span>
                  {{ file.description }}
                  <br />
                </span>
              }
              @if (!file.grouping_id && !file.format_grouping_id && file.filesize && workspaceService.fileMap[file.id].progress == 100) {
                <span>
                  {{ ("download.file_size" | translate) + ": " + (file.filesize | bytesToSize) }}
                  <br />
                </span>
              }
              @if (
                !file.grouping_id &&
                !file.format_grouping_id &&
                ((workspaceService.uploadingFilesSessionMap[file.id] && workspaceService.uploadingFilesSessionMap[file.id].progress != 100) ||
                  (workspaceService.fileMap[file.id] && workspaceService.fileMap[file.id].progress != 100 && !workspaceService.fileMap[file.id].stalled))
              ) {
                <span class="c-orange">
                  {{ "sphere.workspaces.upload_incomplete" | translate }}
                  {{ workspaceService.uploadingFilesSessionMap[file.id] ? workspaceService.uploadingFilesSessionMap[file.id].progress : workspaceService.fileMap[file.id].progress }}%
                  <br />
                </span>
              }
              @if (
                !file.grouping_id && !file.format_grouping_id && workspaceService.fileMap[file.id] && workspaceService.fileMap[file.id].stalled && !workspaceService.uploadingFilesSessionMap[file.id]
              ) {
                <span>
                  <fa-icon icon="exclamation-circle" class="m-r-5"></fa-icon>
                  {{ "sphere.workspaces.delete_reupload" | translate }}
                  <br />
                </span>
              }
              @if (file.date_created) {
                <span>
                  {{ "sphere.workspaces.added_on_date" | translate }} {{ file.date_created | date }}
                  {{ file.user_id == user.id ? "by me" : collaboratorMap[file.user_id] ? "by " + collaboratorMap[file.user_id].name : "" }}
                  <br />
                </span>
              }
              @if (!file.date_created && (file.user_id == user.id || collaboratorMap[file.user_id])) {
                <span>
                  Added by {{ file.user_id == user.id ? "me" : collaboratorMap[file.user_id].name }}
                  <br />
                </span>
              }
            </ng-template>
          </div>
        </myp-list-item>
      }
    }
    <!-- /FILES -->
  </div>
</div>
